// Services/fetchlogin.js
import { USERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchLogin = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(USERS.login, method, body);
  const { code, data } = response;

  // ✅ Login OK
  if (code === 200 && data?.token) {
    // Mantén este shape para que los headers sigan funcionando
    localStorage.setItem("logindata", JSON.stringify(response));
    window.dispatchEvent(new Event("authChange"));

    // devolvemos solo lo útil al store
    return {
      statusCode: 200,
      ...data, // { token, role, name, email, ... }
    };
  }

  // ❌ Credenciales
  if (code === 401) {
    return {
      statusCode: 401,
      message: data?.message || "Credenciales incorrectas",
      errorCode: data?.code,
    };
  }

  // ❌ Bloqueado / revisión / no verificado
  if (code === 403) {
    return {
      statusCode: 403,
      message: data?.message || "Tu cuenta no puede iniciar sesión en este momento.",
      errorCode: data?.code, // EMAIL_NOT_VERIFIED / USER_IN_REVIEW / USER_BANNED_NOSHOW
    };
  }

  // ❌ Cualquier otro error
  return {
    statusCode: code || 500,
    message: data?.message || "Error en login",
    errorCode: data?.code,
  };
};
